import loginLogo from "../assets/images/logos/Login_logo.png";

const images = {
    loginLogo,
};

export default images;